import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/login/auth.service';

export type AsyncFormValidation = {
    [key: string]: string[];
};

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const toastr = inject(ToastrService);
    const router = inject(Router);
    const auth = inject(AuthService);
    const exceptions = ['login'];

    const currentpath = req.url;
    if (exceptions.includes(currentpath)) {
        return next(req);
    }
    const token = auth.getAccessToken();
    if (!token) {
        router.navigate(['/login']);
        return next(req);
    }
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                toastr.error(
                    'Su sesión se ha cerrado por inactividad.',
                    'Error'
                );
                localStorage.clear();
                router.navigate(['/login']);
                window.location.reload();
            }
            if (error.status === 403) {
                toastr.error('Acceso denegado.', 'Error');
            }
            if (error.status >= 500) {
                toastr.error('Error interno del servidor.', 'Error');
            }
            if (error.status === 0) {
                toastr.error('Ha ocurrido un error inesperado.', 'Error');
            }
            return throwError(() => error);
        })
    );
};
